export default {
    email(value) { return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(value); },
    phone(value) { return /^\+?\d{10,14}$/.test(value); }
}